export default __webpack_public_path__ + "assets/keeta_brand_guideline.3936e5.png";